export default __webpack_public_path__ + "static/media/gridduck-white.edfe9e64.png";